import MyFiancesPage from "components/pages/MyFinancesPage";    

export default function CaptureFinancesPersonalFinance(props) {
    return <MyFiancesPage />
}